import { createSlice } from "@reduxjs/toolkit";

const turnSlice = createSlice({
  name: "turn_slice",
  initialState: {
    result: [],
    colors: "",
    inputValues: {
      pl1: "",
      pl2: "",
      pl3: "",
      pl4: "",
    },
    inputString: "",
    cards: {
      turn1: {},
      turn2: {},
      turn3: {},
      turn4: {},
      turn5: {},
    },
    disable: false,
    RangeAnalysis: [],
  },
  reducers: {
    setTurnResult: (state, { payload }) => {
      state.result = payload?.result;
      state.colors = payload?.colors;
    },
    setInputValues: (state, { payload }) => {
      state.inputValues = payload?.values;
      state.inputString = payload?.payload;
    },
    setCards: (state, { payload }) => {
      state.cards = payload;
    },
    disableCalculateButton: (state, { payload }) => {
      state.disable = true;
    },
    setRangeAnalysisResult: (state, { payload }) => {
      state.RangeAnalysis = payload;
    },
    resetTurn: (state, { payload }) => {
      state.disable = false;
      state.cards = {
        turn1: {},
        turn2: {},
        turn3: {},
        turn4: {},
        turn5: {},
      };
      state.inputValues = {
        pl1: "",
        pl2: "",
        pl3: "",
        pl4: "",
      };
      state.inputString = "";
      state.result = [];
      state.colors = [];
      state.RangeAnalysis = [];
    },
  },
});
export const {
  setTurnResult,
  setInputValues,
  setCards,
  disableCalculateButton,
  setRangeAnalysisResult,
  resetTurn,
} = turnSlice.actions;
export default turnSlice.reducer;
